import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { LoadingShimmerComponent } from '../../loading-shimmer/loading-shimmer.component';

@Component({
  selector: 'lib-card',
  imports: [MatIcon, LoadingShimmerComponent],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
  protected readonly CardSize = CardSize;

  public titleText = input.required<string>();
  readonly titleLoading = input<boolean>(false);
  readonly infoLabel = input<string>();
  public readonly size = input<CardSize>(CardSize.large);
}

export enum CardSize {
  small = 1,
  medium,
  large,
}
